<template>
  <div>
    <DataTable :data-model="'vouchers.moneyvouchers'"
               :create-route="'admin.vouchers.moneyvouchers.create'"
               :items="moneyVouchers"
               :permission-name="'Vouchers'"
               :exclude-fields="['id']"
               :remove-path="'/admin/vouchers/deletemoneyvoucher'"
               :items-per-page="5"
               :loading="loadingMoney"
               :remove-note="true"
               @reloadData="reloadMoney(); reloadExpired();"
               :display-name-plural="$t('entities.MoneyVoucher.Plural')"
               :display-name-singular="$t('entities.MoneyVoucher.Singular')">
      <template #cell(redeemed)="row">
        {{ $t('common.'+row.item.redeemed) }}
      </template>
      <template #cell(amount)="row">
        {{ row.item.amount.toLocaleString() + ' Kč' }}
      </template>
      <template #cell(voucherType)="row">
        {{ $t('vouchers.type.' + row.item.voucherType) }}
      </template>
      <template #extraActions="row">
        <el-tooltip
          :content="$t('common.SendByEmail')"
          :enterable="false"
          placement="top">
          <b-button class="mx-1"
                    variant="primary"
                    @click="toSend = row.item; money = true; $refs.sendByEmailModal.show();">
            <font-awesome-icon class="fa-xs"
                               icon="envelope-open" />
          </b-button>
        </el-tooltip>
        <el-tooltip
          :content="$t('common.DownloadPDF')"
          :enterable="false"
          placement="top">
          <b-button class="downloadBtn mx-1"
                    @click="downloadMoney(row.item)">
            <font-awesome-icon class="fa-xs"
                               icon="download" />
          </b-button>
        </el-tooltip>
      </template>
      <template #extraTableActions>
        <b-button
          class="ml-2"
          variant="primary"
          @click="exportMoney()">
          {{ $t('common.ExportMoneyVouchers') }}
        </b-button>
      </template>
    </DataTable>
    <DataTable :data-model="'vouchers.productvouchers'"
               :items="productVouchers"
               :create-route="'admin.vouchers.productvouchers.create'"
               :exclude-fields="['id']"
               :permission-name="'Vouchers'"
               :remove-path="'/admin/vouchers/deleteproductvoucher'"
               :items-per-page="5"
               :loading="loadingProduct"
               :remove-note="true"
               @reloadData="reloadProduct(); reloadExpired();"
               :display-name-plural="$t('entities.ProductVoucher.Plural')"
               :display-name-singular="$t('entities.ProductVoucher.Singular')">
      <template #cell(redeemed)="row">
        {{ $t('common.'+row.item.redeemed) }}
      </template>
      <template #cell(voucherType)="row">
        {{ $t('vouchers.type.' + row.item.voucherType) }}
      </template>
      <template v-if="productTypes.length !== 0"
                #cell(productTypeId)="row">
        {{ productTypes.find(x => x.id === row.item.productTypeId).name }}
      </template>
      <template #extraActions="row">
        <el-tooltip
          :content="$t('common.SendByEmail')"
          :enterable="false"
          placement="top">
          <b-button class="mx-1"
                    variant="primary"
                    @click="toSend = row.item; money = false; $refs.sendByEmailModal.show();">
            <font-awesome-icon class="fa-xs"
                               icon="envelope-open" />
          </b-button>
        </el-tooltip>
        <el-tooltip
          :content="$t('common.DownloadPDF')"
          :enterable="false"
          placement="top">
          <b-button class="downloadBtn mx-1"
                    @click="downloadProduct(row.item)">
            <font-awesome-icon class="fa-xs"
                               icon="download" />
          </b-button>
        </el-tooltip>
      </template>
      <template #extraTableActions>
        <b-button
          class="ml-2"
          variant="primary"
          @click="exportProduct()">
          {{ $t('common.ExportProductVouchers') }}
        </b-button>
      </template>
    </DataTable>
    <DataTable :data-model="'vouchers.expiredvouchers'"
               :items="expiredVouchers"
               :exclude-fields="['id']"
               :permission-name="'Vouchers'"
               :items-per-page="5"
               :loading="loadingExpired"
               :allow-edit="false"
               :allow-create="false"
               :allow-delete="false"
               :allow-view="false"
               :display-name-plural="$t('entities.ExpiredVoucher.Plural')"
               :display-name-singular="$t('entities.ExpiredVoucher.Singular')">
      <template #cell(type)="row">
        {{ $t('vouchers.voucherType.'+row.item.type) }}
      </template>
      <template #cell(voucherType)="row">
        {{ $t('vouchers.type.' + row.item.voucherType) }}
      </template>
    </DataTable>
    <b-modal id="modal-center"
             ref="sendByEmailModal"
             centered
             :static="true">
      <template #modal-header>
        <div class="d-flex justify-content-center w-100 text-center">
          <h3>
            {{ $t('common.SendByEmail') }}
          </h3>
        </div>
      </template>
      <p class="my-4 text-center">
        {{ $t('common.InputEmail') }}
      </p>
      <ValidationObserver
        ref="sendByEmailObserver"
        v-slot="{invalid}"
        tag="form">
        <div class="row">
          <div class="col-lg-4">
            <label for="email">{{ $t('fields.email') }}:</label>
          </div>
          <div class="col-lg-6">
            <ValidationProvider
              name="email"
              rules="required|email"
              v-slot="{errors, classes}">
              <b-form-input
                v-model="email"
                :class="{...classes, myInput: true}" />
              <p class="myInputError mt-2">
                {{ errors[0] }}
              </p>
            </ValidationProvider>
          </div>
        </div>
      </ValidationObserver>
      <template #modal-footer="{ cancel, ok }">
        <b-button
          variant="secondary"
          @click="toSend = {}; $refs.sendByEmailModal.hide();">
          {{ $t('common.Cancel') }}
        </b-button>
        <b-button
          variant="success"
          @click="send();">
          {{ $t('common.Send') }}
        </b-button>
      </template>
    </b-modal>
    <b-modal id="modal-center"
             ref="downloadModal"
             centered
             :ok-disabled="true"
             :static="true">
      <template #modal-header>
        <div class="d-flex justify-content-center w-100 text-center">
          <h3>
            {{ $t('common.Downloading') }}
          </h3>
        </div>
      </template>
      <p class="my-4 text-center">
        {{ $t('common.Generating') }}
      </p>
      <div id="nprogressDownload"
           style="height:25px" />
      <template #modal-footer="{ cancel, ok }">
        <b-button
          variant="danger"
          @click="cancelDownload(); $refs.downloadModal.hide()">
          {{ $t('common.Cancel') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import DataTable from '@components/admin/DataTable';
import NProgress from 'nprogress/nprogress';
import { downloadBlob } from '@utils/downloadBlob';

export default {
  name: 'ViewVouchers',
  components: {
    DataTable
  },
  data() {
    return {
      moneyVouchers: [{}],
      productVouchers: [{}],
      expiredVouchers: [{}],
      productTypes: [],
      loadingMoney: true,
      loadingProduct: true,
      loadingExpired: true,
      toSend: {},
      email: '',
      money: true,
      source: null
    };
  },
  mounted() {
    this.source = this.axios.CancelToken.source();
  },
  created() {
    const moneyVoucherRequest = this.getMoneyVouchersRequest();

    const productVoucherRequest = this.getProductVouchersRequest();

    const productTypesRequest = this.axios.get('/admin/ProductTypes')
      .then((res) => {
        if (res.status === 200 && res.data.result.length > 0) {
          this.productTypes = res.data.result;
        }
        Promise.resolve(this.productVouchers);
      })
      .catch((err) => Promise.reject(err));

    const expiredVoucherRequest = this.getExpiredVouchersRequest();

    Promise.all([moneyVoucherRequest, productVoucherRequest, productTypesRequest, expiredVoucherRequest]).then(() => {
      this.loadingMoney = false;
      this.loadingProduct = false;
      this.loadingExpired = false;
    });
  },
  methods: {
    cancelDownload() {
      this.source.cancel();
      this.source = this.axios.CancelToken.source();
    },
    reloadMoney() {
      this.loadingMoney = true;
      this.getMoneyVouchersRequest();
      this.loadingMoney = false;
    },
    reloadProduct() {
      this.loadingProduct = true;
      this.getProductVouchersRequest();
      this.loadingProduct = false;
    },
    reloadExpired() {
      this.loadingExpired = true;
      this.getExpiredVouchersRequest();
      this.loadingExpired = false;
    },
    getMoneyVouchersRequest() {
      return this.axios.get('/admin/vouchers/getallmoneyvouchers')
        .then((res) => {
          if (res.status === 200 && res.data.result.length > 0) {
            this.moneyVouchers = res.data.result;
          }
          Promise.resolve(this.moneyVouchers);
        })
        .catch((err) => Promise.reject(err));
    },
    getProductVouchersRequest() {
      return this.axios.get('/admin/vouchers/getallproductvouchers')
        .then((res) => {
          if (res.status === 200 && res.data.result.length > 0) {
            this.productVouchers = res.data.result;
          }
          Promise.resolve(this.productVouchers);
        })
        .catch((err) => Promise.reject(err));
    },
    getExpiredVouchersRequest() {
      return this.axios.get('/admin/vouchers/getallexpiredvouchers')
        .then((res) => {
          if (res.status === 200 && res.data.result.length > 0) {
            this.expiredVouchers = res.data.result;
          }
          Promise.resolve(this.expiredVouchers);
        })
        .catch((err) => Promise.reject(err));
    },
    send() {
      const url = this.money ? '/admin/vouchers/sendmoneyvoucher' : '/admin/vouchers/sendproductvoucher';
      return this.axios.put(url, {
        Id: this.toSend.id,
        Email: this.email
      }).then((res) => {
        if (res.status === 204) {
          this.$root.$bvToast.toast(this.$t('common.SuccessfullySent'), {
            title: this.$t('CreateMoneyVoucher.SuccessToast.Title'),
            variant: 'success',
            toaster: 'b-toaster-top-right'
          });
        }
        this.toSend = {};
        this.email = '';
        this.$refs.sendByEmailModal.hide();
      }).catch(() => {
        this.$root.$bvToast.toast(this.$t('common.CouldNotSend'), {
          title: this.$t('CreateMoneyVoucher.FailToast.Title'),
          variant: 'danger',
          toaster: 'b-toaster-top-right'
        });
        this.toSend = {};
        this.email = '';
        this.$refs.sendByEmailModal.hide();
      });
    },
    downloadMoney(item) {
      this.$refs.downloadModal.show();
      NProgress.configure({ parent: '#nprogressDownload' });
      NProgress.start();
      this.axios.get('admin/vouchers/printmoneyvoucher', {
        params: {
          Id: item.id
        },
        responseType: 'arraybuffer',
        cancelToken: this.source.token
      }).then((response) => {
        const today = new Date();
        downloadBlob(
          response.data,
          `Export voucheru ${today.toLocaleDateString('en-US')}.pdf`,
          'application/pdf'
        );
        this.$refs.downloadModal.hide();
      }).catch((thrown) => {
        if (this.axios.isCancel(thrown)) {
          this.$root.$bvToast.toast(this.$t('common.DownloadCancel'), {
            title: this.$t('common.Cancelled'),
            variant: 'danger',
            toaster: 'b-toaster-top-right'
          });
          this.$refs.downloadModal.hide();
        }
      })
        .finally(() => {
          NProgress.configure({ parent: 'body' });
          NProgress.done();
        });
    },
    downloadProduct(item) {
      this.$refs.downloadModal.show();
      NProgress.configure({ parent: '#nprogressDownload' });
      NProgress.start();
      this.axios.get('admin/vouchers/printproductvoucher', {
        params: {
          Id: item.id
        },
        responseType: 'arraybuffer',
        cancelToken: this.source.token
      }).then((response) => {
        const today = new Date();
        downloadBlob(
          response.data,
          `Export voucheru ${today.toLocaleDateString('en-US')}.pdf`,
          'application/pdf'
        );
        this.$refs.downloadModal.hide();
      }).catch((thrown) => {
        if (this.axios.isCancel(thrown)) {
          this.$root.$bvToast.toast(this.$t('common.DownloadCancel'), {
            title: this.$t('common.Cancelled'),
            variant: 'danger',
            toaster: 'b-toaster-top-right'
          });
          this.$refs.downloadModal.hide();
        }
      })
        .finally(() => {
          NProgress.configure({ parent: 'body' });
          NProgress.done();
        });
    },
    exportMoney() {
      this.$refs.downloadModal.show();
      NProgress.configure({ parent: '#nprogressDownload' });
      NProgress.start();
      this.axios.get('admin/vouchers/exportmoneyvoucher', {
        responseType: 'arraybuffer',
        cancelToken: this.source.token
      }).then((response) => {
        const today = new Date();
        downloadBlob(
          response.data,
          `Export voucherů ${today.toLocaleDateString('en-US')}.xlsx`,
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        );
        this.$refs.downloadModal.hide();
      }).catch((thrown) => {
        if (this.axios.isCancel(thrown)) {
          this.$root.$bvToast.toast(this.$t('common.DownloadCancel'), {
            title: this.$t('common.Cancelled'),
            variant: 'danger',
            toaster: 'b-toaster-top-right'
          });
          this.$refs.downloadModal.hide();
        }
      })
        .finally(() => {
          NProgress.configure({ parent: 'body' });
          NProgress.done();
        });
    },
    exportProduct() {
      this.$refs.downloadModal.show();
      NProgress.configure({ parent: '#nprogressDownload' });
      NProgress.start();
      this.axios.get('admin/vouchers/exportproductvoucher', {
        responseType: 'arraybuffer',
        cancelToken: this.source.token
      }).then((response) => {
        const today = new Date();
        downloadBlob(
          response.data,
          `Export voucherů ${today.toLocaleDateString('en-US')}.xlsx`,
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        );
        this.$refs.downloadModal.hide();
      }).catch((thrown) => {
        if (this.axios.isCancel(thrown)) {
          this.$root.$bvToast.toast(this.$t('common.DownloadCancel'), {
            title: this.$t('common.Cancelled'),
            variant: 'danger',
            toaster: 'b-toaster-top-right'
          });
          this.$refs.downloadModal.hide();
        }
      })
        .finally(() => {
          NProgress.configure({ parent: 'body' });
          NProgress.done();
        });
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@colors';
.downloadBtn {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  background-color: #c95328;
  color: $text-on-secondary;
  border: none;
  &:hover {
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
    background-color: darken($secondary-variant-color, 10%);
    color: $text-on-secondary;
  }
}
</style>
